import { ErrorFallback } from '@w/ui/system/error-boundary'
import { startBrowserRuntime } from '@w/runtime/browser'
import { currentLocation } from '@w/react-router'
import { RuntimeStartup } from './shell/runtime-startup'
import { mountApp } from '@w/utils-fe/mount-app'
import { feEnv } from '@w/utils-fe/env'
import { RouterProvider } from './router/flashcards-fe.router-bindings'
import { createFlashcardsFeRouterProdContext, flashcardsClientTel } from './router/flashcards-fe.router-ctx-prod'
import { createFlashcardsFeRouter } from './router/flashcards-fe.router'
import { Shell } from './shell/shell'
import { FlashcardsDevtools } from './shell/app'
import { installReadableFlashcardsVersion } from './server/flashcards-version-be'
// oxlint-disable-next-line import/no-unassigned-import -- CSS side-effect import
import './index.css'

installReadableFlashcardsVersion()
startBrowserRuntime({ app: 'Flashcards', version: globalThis.APP_VERSION, launchPath: currentLocation().pathname })

mountApp(<RuntimeStartup app={createFlashcardsFeRouterProdContext().then((context) => (
  <RouterProvider router={createFlashcardsFeRouter(context)} wrapper={Shell} errorFallback={ErrorFallback} devtools={<FlashcardsDevtools />} />
))} />)

if (feEnv().isProd) {
  void import('./register-app-updates').then(({ registerAppUpdates }) => {
    registerAppUpdates(flashcardsClientTel.current)
    return null
  }).catch(error => { flashcardsClientTel.current.error(error, { operation: 'serviceWorker.load' }) })
}
